import { formatDistanceToNowStrict } from "date-fns";

/** "3 days ago" for an epoch-seconds value, or null when absent/unparseable. */
export function relativeTime(epoch?: number | null): string | null {
  if (!epoch) return null;
  const date = new Date(epoch * 1000);
  return Number.isNaN(date.getTime()) ? null : formatDistanceToNowStrict(date, { addSuffix: true });
}
